import React from "react"
import Pagination from "rc-pagination"
import useDictionary from "../../hooks/useDictionary"

interface ListingPaginationProps {
  results: any[]
  hitsPerPage: number
  currentPage: number
  handlePageClick: (x: number) => void
  pageContext: any
}

const defaultProps = {}

export const ListingPagination: React.FC<ListingPaginationProps> = props => {
  if (!props.results) return null
  if (!props.hitsPerPage) return null
  if (props.results.length <= props.hitsPerPage) return null

  return (
    <section className="pagination">
      <div className="grid-container">
        <div className="grid-x grid margin-x">
          <div className="cell">
            <Pagination
              onChange={props.handlePageClick}
              defaultCurrent={1}
              current={props.currentPage}
              total={props.results.length}
              pageSize={props.hitsPerPage}
              prevIcon={useDictionary("Prev", props.pageContext.locale)}
              nextIcon={useDictionary("Next", props.pageContext.locale)}
              jumpPrevIcon={"..."}
              jumpNextIcon={"..."}
              showPrevNextJumpers={true}
              showLessItems={true}
              locale={locale}
              itemRender={itemRender}
            />
          </div>
        </div>
      </div>
    </section>
  )
}

ListingPagination.defaultProps = defaultProps

export default ListingPagination

const locale = {
  // Options.jsx
  items_per_page: "/ page",
  jump_to: "Go to",
  jump_to_confirm: "confirm",
  page: "",
  // Pagination.jsx
  prev_page: "Previous Page",
  next_page: "Next Page",
  prev_5: "Previous 5 Pages",
  next_5: "Next 5 Pages",
  prev_3: "Previous 3 Pages",
  next_3: "Next 3 Pages",
}

const itemRender = (
  current: number,
  type: string,
  element: React.ReactNode
) => {
  if (type === "page") {
    const link =
      typeof window !== `undefined`
        ? `${window.location.origin}${window.location.pathname}?p=${current}`
        : ""
    return <a href={link}>{current}</a>
  }
  return element
}
